/**
 * Returns if collection should be printed/displayed based on passed collection object.
 * @param {Collection} collectionObject - collection object: brand, show, station, genre...
 */
export default function shouldDisplayCollection(collectionObject) {
  return collectionObject && collectionObject.collection && collectionObject.collection.length;
}
